import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import appReducer from "./appReducer";

const configureStore = () => {
  /* composeWithDevTools is added to use the redux dev tools.
     See https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
     This is really handy to see the application state and dispatch actions for example. */
  const store = createStore(
    appReducer,
    composeWithDevTools(applyMiddleware(thunk))
  );

  /* When using redux with webpack hot module replacement it is required to explicitly hot swap out the reducers to
     avoid state issues.
     See: https://github.com/reactjs/react-redux/releases/tag/v2.0.0 */
  if (module.hot) {
    module.hot.accept("./appReducer", () => {
      // eslint-disable-next-line global-require
      const nextAppReducer = require("./appReducer");
      store.replaceReducer(nextAppReducer);
    });
  }

  return store;
};

const store = configureStore();

export default store;

export type AppDispatch = typeof store.dispatch;
